import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { map } from 'rxjs/operators'

import { AuthPipeGenerator, redirectLoggedInTo, canActivate } from '@angular/fire/compat/auth-guard';


const redirectLoggedInToItems = () => redirectLoggedInTo(['/dashboard']);
const redirectUnauthorizedOrUnverifiedUser: AuthPipeGenerator = (next) =>
  map(user => {
    // verifica se o usuário esta logado
    if (user) {      
      // verifica se o email está verificado
      if (user.emailVerified) {
        // retorna true, ou seja, permite a rota
        return true;
      } else {
        // caso o email nao esteja verificado, redireciona
        return ['/user/verify-email'];
      }
    // caso o usuário não esteja logado
    } else {
      // captura o path que foi tentado acessar
      const path = location.pathname;
      // captura o queryparams que foi tentado acessar
      const params = next.queryParams
      // grava no local storage essas informações
      // para depois num login com sucesso ser direcionado para
      // esse caminho que foi tentado
      localStorage.setItem('returnUrl', JSON.stringify({path, params}));
      //redireciona para a página de login
      return ['/login'];      
    }
  })

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},  
  {
    path: '', component: LayoutComponent,    
    children: [
      {path: 'planos', loadChildren: ()=> import('./pages/planos-precos/planos-precos.module').then( m=> m.PlanosPrecosModule)},
      {path: 'registro', loadChildren: ()=> import('./pages/registro/registro.module').then( m=> m.RegistroModule), ...canActivate(redirectLoggedInToItems)},
      {path: 'login', loadChildren: ()=> import('./pages/login/login.module').then( m=> m.LoginModule ), ...canActivate(redirectLoggedInToItems)},
      {path: 'dashboard', loadChildren: ()=> import('./pages/dashboard/dashboard.module').then( m=> m.DashboardModule ), ...canActivate(redirectUnauthorizedOrUnverifiedUser)},
      {path: 'cart', loadChildren: ()=> import('./pages/cart/cart.module').then( m=> m.CartModule ), ...canActivate(redirectUnauthorizedOrUnverifiedUser)},
      {path: 'testamento', loadChildren: ()=> import('./pages/documentos/testamento/testamento.module').then( m=> m.TestamentoModule ), ...canActivate(redirectUnauthorizedOrUnverifiedUser)},
      {path: 'doacao', loadChildren: ()=> import('./pages/documentos/doacao/doacao.module').then( m=> m.TestamentoModule ), ...canActivate(redirectUnauthorizedOrUnverifiedUser)},
      {path: 'pendencias', loadChildren: ()=> import('./pages/pendencias/pendencias.module').then( m=> m.PendenciasModule ), ...canActivate(redirectUnauthorizedOrUnverifiedUser)},
      {path: 'user', loadChildren: ()=> import('./pages/user/user.module').then( m=> m.UserModule )},
      {path: 'valida', loadChildren: ()=> import('./pages/valida/valida.module').then( m=> m.ValidaModule )},
      {path: '404', loadChildren: ()=> import('./components/not-found/not-found.module').then( m=> m.NotFoundModule )},
      {path: 'resolve-desafio', loadChildren: ()=> import('./pages/resolve-desafio/resolve-desafio.module').then( m=> m.ResolveDesafioModule )},
      {path: '**', pathMatch: 'full', redirectTo: '/404'}
    ]
  },  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
